import React from "react";
import UserTable from "src/pages/user";

export default function UserPage() {
  return <UserTable />;
}
